import * as React from "react";
import { useTranslation } from "react-i18next";
import { DeleteButton } from "components/Button/DeleteButton";

interface GroupingTemplateOptionsProps {
  onClose: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

export const GroupingTemplateOptions: React.FC<GroupingTemplateOptionsProps> = (
  props
) => {
  const { t } = useTranslation();

  const handleEdit = () => {
    props.onEdit();
    props.onClose();
  };

  const handleDelete = () => {
    props.onDelete();
    props.onClose();
  };

  return (
    <div
      className="mx-3 origin-top-right absolute right-7 top-0 w-48 mt-1 rounded-md shadow-lg z-10 bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-200 focus:outline-none"
      role="menu"
      aria-orientation="vertical"
    >
      <div className="py-1" role="none">
        <button
          onClick={handleEdit}
          className="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100 w-full text-left flex items-center"
          role="menuitem"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="text-gray-500 mr-3 h-6 w-6 flex-shrink-0 mt-0.5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
          </svg>
          {t("riskTemplate.groupings.option_edit")}
        </button>
      </div>
      <div className="py-1" role="none">
        <DeleteButton onClick={handleDelete} flat fullWidth>
          {t("riskTemplate.groupings.option_delete")}
        </DeleteButton>
      </div>
    </div>
  );
};
